/* eslint-disable react/jsx-props-no-spreading */
import React, { ReactElement } from 'react'
import { UseFormRegister } from 'react-hook-form'
import type { Clip } from '../video_player/VideoPlayer'

export const camelCaseToClassicCase = (varName: string): string => {
  return varName.replace(/([A-Z, 0-9])/g, ' $1').replace(/^./, str => str.toUpperCase())
}

export default function FormValues({
  register,
  values,
  labelInfo,
  currentClip,
}: {
  register: UseFormRegister<Record<string, boolean>>
  values: string[]
  labelInfo: Record<string, string>
  currentClip: Clip | null
}): ReactElement {
  const checkboxes: ReactElement[] = []
  const prevLabels = currentClip ? currentClip.labels : {}
  // console.log(prevLabels)
  values.forEach((item: string) => {
    const tooltip = labelInfo && labelInfo[item] ? labelInfo[item] : 'No description available'
    const isChecked = prevLabels[item] || false
    checkboxes.push(
      <label htmlFor={item} key={item} title={tooltip}>
        <input {...register(`${item}`)} type="checkbox" id={item} defaultChecked={isChecked} />
        <span>{camelCaseToClassicCase(item)}</span>
      </label>,
    )
  })

  return <> {checkboxes}</>
}
